<template>
    <div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <div class="flex-sm">
                    <div class="pr-3">
                      <div class="form-group">
                        <label>Title</label>
                        <input type="text" v-model="course.title" class="form-control">
                      </div>
                    </div>
                    <div class="pr-3">
                      <div class="form-group">
                        <label>Type</label>
                        <select class="form-control" v-model="course.commercial_training_course_type_id">
                          <option :value="1">Webinar</option>
                          <option :value="2">Video</option>
                          <option :value="3">On Site</option>
                        </select>
                      </div>
                    </div>
                  <div class="pr-3" v-if="course.commercial_training_course_type_id === 2">
                    <div class="form-group">
                      <label>Video ID</label>
                      <input type="text" v-model="course.video_embed_id" class="form-control">
                    </div>
                  </div>
                  <div class="pr-3" v-if="course.commercial_training_course_type_id !== 2">
                    <div class="form-group">
                      <label>Open for Bookings</label>
                      <select class="form-control" v-model="course.bookings_open">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="flex" v-if="course.commercial_training_course_type_id !== 2">
                    <div class="flex" v-if="editing_dates">
                        <div class="form-group pr-3">
                            <label>Start Time</label>
                            <datepicker input-class="form-control" v-model="new_start_date" :show-second="false" :minute-step="15" :disabled-date="dateNotBeforeToday" type="datetime" value-type="timestamp"></datepicker>
                        </div>
                        <div class="form-group">
                            <label>End Time</label>
                            <datepicker input-class="form-control" v-model="new_end_date" :show-second="false" :minute-step="15" :disabled-date="dateNotBeforeStart" type="datetime" value-type="timestamp"></datepicker>
                        </div>
                        <div @click="editing_dates = false, new_end_date = null, new_start_date = null">
                            <i class="fal fa-times"></i>
                        </div>
                    </div>
                    <div v-else class="flex">
                        <div class="form-group pr-3">
                            <label>Start Time</label>
                            {{ course.friendly_start_date }}
                        </div>
                        <div class="form-group">
                            <label>End Time</label>
                            {{ course.friendly_end_date }}
                        </div>
                        <div @click="editing_dates = true">
                            <i class="fal fa-pencil"></i>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                    <label>Summary</label>
                    <wysiwyg v-model="course.summary"></wysiwyg>
                </div>
                <div class="form-group">
                    <label>Description</label>
                    <wysiwyg v-model="course.description"></wysiwyg>
                </div>
                <div class="flex">
                    <div class="half-width pr-3">
                        <div class="form-group mb-0 full-height flex flex-col">
                            <label>Upload Image</label>
                            <form :action="`${$aws_upload_url}`" method="post"
                                  enctype="multipart/form-data" id="amazon_form">
                                <input type="hidden" name="policy" :value="aws_policy">
                                <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                <input type="hidden" name="x-amz-date" :value="aws_date">
                                <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                <input type="hidden" name="acl" value="private">
                                <input type="hidden" name="success_action_redirect" value="/news/manage">
                                <input type="hidden" name="Content-Type" v-model="filetype">
                                <input type="hidden" name="key" v-model="course.filename">
                            </form>
                            <vue-dropzone
                                ref="fileUploadDropzone"
                                id="dropzone"
                                :options="dropzoneOptions"
                                v-on:vdropzone-file-added="fileAddedToDropZone"
                                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                :useCustomSlot="true"
                            >
                                <div>
                                    <div class="mb-3">
                                        DRAG AND DROP FILE
                                    </div>
                                    <div class="mb-3">
                                        OR
                                    </div>
                                    <div>
                                        <a class="btn-secondary-outline">
                                            Choose a file
                                        </a>
                                    </div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                </div>
                <div class="align-right mt-3">
                    <a class="btn-primary" @click.prevent="save()">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: [
       'aws_policy',
       'aws_credential',
       'aws_date',
       'aws_signature',
       'prop_course',
    ],
    components: {
        'vue-dropzone': vue2Dropzone,
        'datepicker': DatePicker,
    },
    data() {
        return {
          course: {},
          editing_dates: false,
          new_start_date: null,
          new_end_date: null,
            loading: true,
            filename: '',
            filetype: '',
            saving: false,
            uploaded_file: null,
            dropzoneOptions: {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
            },
        };
    },
    mounted() {
      this.course = this.prop_course;
      if (this.prop_course.bookings_open === 1) {
        this.course.bookings_open = true;
      } else {
        this.course.bookings_open = false;
      }
    },
    methods: {
        fileAddedToDropZone(uploadedFile) {
            const extension = uploadedFile.name.replace(/^.*\./, '');

            const allowed_extensions = [
                'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp',
            ];

            if(!allowed_extensions.includes(extension.toLowerCase())) {
                this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
                Swal.fire({
                    title: 'Invalid File Type',
                    icon: 'error',
                    text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\','
                });
                return;
            }

            if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
                this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
            }

            const filename = 'commercial_training_course_images/' + Date.now();
            this.course.filename = filename + '.' + extension;

            this.filetype = uploadedFile.type;
            this.uploaded_file = uploadedFile;
        },
        fileRemovedFromDropZone(file) {
          this.uploaded_file = null;
        },
        save() {
          this.saving = true;

            const validationErrors = Validate({
                title: this.course.title,
                summary: this.course.summary,
                description: this.course.description,
            }, {
                title: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                summary: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                description: {
                    presence: {
                        allowEmpty: false,
                    },
                },
            });

            if (validationErrors) {
                this.saving = false;
                Swal.fire({
                    title: 'Unable to save course',
                    icon: 'error',
                    html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
                });
                return;
            }

            if(this.course.commercial_training_course_type_id === 2 && this.course.video_embed_id === null) {
              this.saving = false;
              Swal.fire({
                title: 'Video ID Missing',
                icon: 'error',
                html: `<div class="mb-3">Please enter a youtube video ID</div>`,
              });
              return;
            }

            if(this.uploaded_file !== null) {
              this.saving_file = true;

              let form_data = new FormData(document.querySelector('#amazon_form'));
              form_data.append('file', this.uploaded_file);
              axios({
                method: 'post',
                url: this.$aws_upload_url,
                data: form_data,
                headers: {'Content-Type': 'multipart/form-data' }
              }).then(() => {
                this.updateTrainingCourse();
              });

            } else {
              this.updateTrainingCourse();
            }

        },
        updateTrainingCourse() {
          if(this.course.commercial_training_course_type_id === 2) {
            this.course.bookings_open = 0;
          }
          axios.post('/commercial/training/update',{
            course: this.course,
            new_start_date: this.new_start_date,
            new_end_date: this.new_end_date,
          }).then((response) => {
            window.location.href = '/commercial/training';
          });
        },
        dateNotBeforeToday(date) {
          const today = new Date();

          if(this.new_end_date === null) {
            return date < today;
          }

            const end = new Date(this.new_end_date);
            today.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);
            return date < today || date > end;
        },
        dateNotBeforeStart(date) {
          const today = new Date();

          if(this.new_start_date === null) {
            return date < today;
          }

          const start = new Date(this.new_start_date);
          today.setHours(0, 0, 0, 0);
          start.setHours(0, 0, 0, 0);
          date.setHours(0, 0, 0, 0);
          return date < today || date < start;
        },
    },
};
</script>
